export default __webpack_public_path__ + "static/media/notification-6.f3684347.mp3";